<script lang="ts">
	import { t } from 'svelte-i18n'
	import { DataTable, TableActions } from '@repo/commons/components'
	import type { TableColumn, TableData } from '@repo/commons/models'
	import LeverDefaultValueCell from './LeverDefaultValueCell.svelte'
	import LeverPossibleValuesCell from './LeverPossibleValuesCell.svelte'

	type Props = {
		rows: TableData[]
		loading: boolean
		sortable: boolean
		emptyText?: string
		onEdit: (row: TableData) => void
		onDelete: (row: TableData) => void
	}

	const { rows, loading, sortable, emptyText, onEdit, onDelete }: Props = $props()

	const columns: TableColumn[] = $derived([
		{ key: 'name', label: $t('Table.name'), sortable },
		{
			key: 'possibleValues',
			label: $t('LeversTable.possibleValues'),
			component: LeverPossibleValuesCell,
			sortable: false
		},
		{
			key: 'defaultValue',
			label: $t('LeversTable.value'),
			component: LeverDefaultValueCell,
			sortable
		},
		{
			key: 'actions',
			label: $t('Table.actions'),
			width: '160px',
			component: TableActions,
			componentProps: { onEdit, onDelete },
			sortable: false
		}
	])
</script>

<DataTable data={rows} {columns} {loading} {emptyText} />
